import { CachedOutlined, CleaningServicesOutlined, RestoreOutlined } from '@mui/icons-material'
import "./ClearCacheButton.css"
import useCache from '../../hooks/use-cache'

const ClearCacheButton = ({
  children,
  keys,
  style
}) => {

  const { clear } = useCache()

  const onClick = () => {
    keys && clear(keys)
  }

  return <div className="clear-cache-button__wrapper" style={style}>
    <button
      className="clear-cache-button"
      onClick={onClick}
    >
      <span>
        {children || "Purge Cache"}
        <CachedOutlined color='error' style={{ marginLeft: 7 }} />
      </span>
    </button>
  </div>
}

export default ClearCacheButton